<template>
  <el-dialog title="报销申请" :close-on-click-modal="false" v-model="visible" width="550px">
    <el-scrollbar height="470px">
      <el-form :model="dataForm" ref="dataFormRef" :rules="dataRule" label-width="100px">
        <el-form-item label="报销种类" prop="type">
          <el-radio-group v-model="dataForm.type">
            <el-radio-button label="普通报销"></el-radio-button>
            <el-radio-button label="差旅报销"></el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="借款金额" prop="anleihen">
          <el-input
            v-model="dataForm.anleihen"
            placeholder="借款金额"
            style="width:160px;"
            clearable="clearable"
            prop="anleihen"
          />
          <span class="note">请如实填写借款金额</span>
        </el-form-item>
        <div v-for="(one, $index) in dataForm.project" class="project" :key="$index">
          <h3>【 报销项目 】</h3>
          <i class="el-icon-delete icon-delete" @click="deleteProjectHandle($index)"></i>
          <el-form-item
            label="项目名称"
            :prop="'project.' + $index + '.title'"
            :rules="{
							required: true,
							message: '项目名称必填'
						}"
          >
            <el-input
              v-model="one.title"
              style="width:95%"
              maxlength="20"
              clearable
            />
          </el-form-item>
          <el-form-item
            label="项目类别"
            :prop="'project.' + $index + '.type'"
            :rules="{
							required: true,
							message: '项目类别必填'
						}"
          >
            <el-select v-model="one.type" class="input" size="medium" clearable>
              <el-option label="办公用品" value="办公用品" />
              <el-option label="招待费" value="招待费" />
              <el-option label="采购费" value="采购费" />
              <el-option label="劳务费" value="劳务费" />
              <el-option label="培训费" value="培训费" />
              <el-option label="维修费" value="维修费" />
              <el-option label="办公费" value="办公费" />
              <el-option label="其他" value="其他" />
            </el-select>
            <span class="note">请选择项目报销的类别</span>
          </el-form-item>
          <el-form-item label="备注信息" prop="projectDesc">
            <el-input
              v-model="one.desc"
              type="textarea"
              maxlength="50"
              style="width:95%"
              resize="none"
              show-word-limit
              clearable
            />
          </el-form-item>
          <el-form-item
            label="报销金额"
            :prop="'project.' + $index + '.money'"
            :rules="{
							required: true,
							pattern:
								'(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)',
							message: '报销金额必填'
						}"
          >
            <el-input
              v-model="one.money"
              size="medium"
              style="width:160px;"
              clearable
            />
            <span class="note">认真核对该项目的报销金额</span>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
    <template #footer>
			<span class="dialog-footer">
				<el-button type="danger" @click="addHandle">添加项目</el-button>
				<el-button @click="close">取消</el-button>
				<el-button type="primary" @click="dataFormSubmit">确定</el-button>
			</span>
    </template>
  </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, reactive, ref, watch } from 'vue'
import utils from '@/utils/utils'
const props = defineProps({
  modelValue: {
    type: Boolean,
    require: true,
    default: false
  }
})
const visible = ref(props.modelValue)
const emits = defineEmits(['update:modelValue', 'refreshDataList'])
const dataForm = reactive({
  type: '普通报销',
  anleihen: null,
  project: []
})
const dataRule = {
  anleihen: [
    {
      required: true,
      pattern:
        '(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)',
      message: '金额格式错误'
    }
  ]
}

const addHandle = () => {
  if (dataForm.project.length === 5) {
    utils.showWarning('这笔报销不能超过5个报销项目')
    return
  }
  dataForm.project.push({ title: null, type: null, desc: null, money: null })
  utils.showSuccess('添加成功')
}

const deleteProjectHandle = (index) => {
  if (dataForm.project.length === 1) {
    utils.showWarning('不能删除仅存的报销项目')
  } else {
    dataForm.project.splice(index, 1)
    utils.showSuccess('删除成功')
  }
}

const close = () => {
  visible.value = false
  emits('update:modelValue', false)
}
const dataFormRef = ref()
watch(() => props.modelValue, (value, o) => {
  visible.value = value
  if (value) {
    dataFormRef.value = []
    dataForm.type = '普通报销'
    dataForm.anleihen = null
    dataForm.project = [{ title: null, type: null, desc: null, money: null }]
  }
})
</script>
